import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'szz-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  @Input() isUserUpdated: boolean = false;

  constructor() { }

  ngOnInit(): void {}
}
